export default "__VITE_ASSET__G_69eepp__"